import debounce from "./helpers/custom-debounce";
import suggest from "./dadata-functions/suggest";
import reg_keyboard from "./helpers/reg_keyboard";
import forEach from "./helpers/customForEach";
import sendOnChange from "./helpers/sendOnChange";
import postData from "./helpers/postData";
import ignoreTypes from "./helpers/ignoreTypes";
import search_mask from "./helpers/search_mask";
import initPhoneMaskForModal from "./helpers/phoneMask";

function initModalQuiz() {
    const modal_quiz = document.getElementById("modal-quiz");
    initPhoneMaskForModal(modal_quiz);
    if (modal_quiz) {
        const quiz_title = modal_quiz.querySelector(".modal-quiz__question");
        const quiz_next = modal_quiz.querySelector(".modal-quiz__button.next");
        const quiz_back = modal_quiz.querySelector(".modal-quiz__button.back");
        const quiz_step = modal_quiz.querySelector(
            ".modal-quiz__procces .current"
        );
        const quiz_step_line = modal_quiz.querySelector(".modal-quiz__steps");
        const quiz_close = modal_quiz.querySelectorAll(".quiz_close");

        if (quiz_close) {
            quiz_close.forEach(function (item) {
                item.addEventListener("click", function () {
                    modal_quiz
                        .querySelector(".modal-form-quiz-result")
                        .classList.add("hide");
                    modal_quiz
                        .querySelector(".search-address__results")
                        .classList.add("hide");
                    modal_quiz
                        .querySelector(".modal-form-quiz-data")
                        .classList.remove("hide");
                    modal_quiz
                        .querySelector(".modal-quiz-flex")
                        .classList.remove("hide");
                });
            });
        }

        quiz_next.addEventListener("click", (event) => {
            event.preventDefault();
            let current_page = quiz_next.dataset.page;
            let back_page = quiz_back.dataset.page;
            let next = +current_page + 1;
            let back = +back_page + 1;
            if (next > quiz_next.dataset.max) {
                modal_quiz
                    .querySelector(".modal-quiz-flex")
                    .classList.add("hide");
                modal_quiz
                    .querySelector(".search-address__results")
                    .classList.remove("hide");
            } else {
                quiz_next.dataset.page = next;
                quiz_back.dataset.page = back;
                quiz_step.innerHTML = next;
                quiz_step_line.dataset.step = next;

                switch (next) {
                    case 1:
                        quiz_title.innerHTML = quiz_title.dataset.step1;
                        break;
                    case 2:
                        quiz_title.innerHTML = quiz_title.dataset.step2;
                        break;
                    case 3:
                        quiz_title.innerHTML = quiz_title.dataset.step3;
                        break;
                    case 4:
                        quiz_title.innerHTML = quiz_title.dataset.step4;
                        break;
                }

                if (next == quiz_next.dataset.max) {
                    quiz_next.querySelector("span").innerHTML = "Последний шаг";
                } else {
                    quiz_next.querySelector("span").innerHTML = "Далее";
                }
                modal_quiz
                    .querySelectorAll(".modal-quiz__js-step > div")
                    .forEach((v) => {
                        v.classList.add("hide");
                    });
                modal_quiz
                    .querySelector("#quiz_step_" + next)
                    .classList.remove("hide");
                if (quiz_back.dataset.page != 0) {
                    quiz_back.classList.remove("hidden");
                }
            }
        });
        quiz_back.addEventListener("click", (event) => {
            event.preventDefault();
            let current_page = quiz_back.dataset.page;
            let back_page = quiz_back.dataset.page;
            if (back_page != 0) {
                let next = back_page == 0 ? +current_page - 1 : 1;
                let back = +back_page - 1;
                quiz_next.dataset.page = next;
                quiz_back.dataset.page = back;
                quiz_step.innerHTML = back_page;
                quiz_step_line.dataset.step = back_page;

                switch (back + 1) {
                    case 1:
                        quiz_title.innerHTML = quiz_title.dataset.step1;
                        break;
                    case 2:
                        quiz_title.innerHTML = quiz_title.dataset.step2;
                        break;
                    case 3:
                        quiz_title.innerHTML = quiz_title.dataset.step3;
                        break;
                    case 4:
                        quiz_title.innerHTML = quiz_title.dataset.step4;
                        break;
                }

                if (next == quiz_next.dataset.max) {
                    quiz_next.querySelector("span").innerHTML = "Последний шаг";
                } else {
                    quiz_next.querySelector("span").innerHTML = "Далее";
                }

                modal_quiz
                    .querySelectorAll(".modal-quiz__js-step > div")
                    .forEach((v) => {
                        v.classList.add("hide");
                    });
                modal_quiz
                    .querySelector("#quiz_step_" + current_page)
                    .classList.remove("hide");
                if (quiz_back.dataset.page == 0) {
                    quiz_back.classList.add("hidden");
                }
            }
        });

        const form_quiz = modal_quiz.querySelector(".js-form-quiz");
        const phone_quiz = form_quiz.querySelector(".check-mobilephone");
        const address_quiz = form_quiz.querySelector(".quiz-address");
        const form_quiz_button = form_quiz.querySelector(".js-send-button");
        let form_quiz_button_t = "";
        if (form_quiz_button) {
            form_quiz_button_t = form_quiz_button.innerHTML;
        }
        phone_quiz.addEventListener("input", () => {
            modal_quiz
                .querySelector(".placeholder-error")
                .classList.add("hide");
        });
        if (address_quiz) {
            const quiz_suggestions_wrap = modal_quiz.querySelector(".quiz_suggestions")
            let streetInp = document.querySelector(".field.quiz-address");
            let street_id = "";
            address_quiz.addEventListener("input", debounce((e) => onQuizAddressChange(e), 500));

            function onQuizAddressChange(e) {
                if (e.target.value.length > 1) {
                    quiz_suggestions_wrap.style.display = "block";
                    let promise = suggest(e.target.value, street_id);
                    promise
                        .then(function (response) {
                            return response.json();
                        })
                        .then(function (suggestions) {
                            quiz_suggestions_wrap.innerHTML = "";
                            for (let key in suggestions["suggestions"]) {
                                if (
                                    ignoreTypes[
                                        suggestions["suggestions"][key]["data"]
                                            .street_type
                                        ]
                                ) {
                                    continue;
                                }

                                let street =
                                    suggestions["suggestions"][key]["data"][
                                        "street_with_type"
                                        ];
                                if (street) {
                                    let house =
                                        suggestions["suggestions"][key]["data"][
                                            "house"
                                            ];
                                    let house_in =
                                        house === null ? "" : ", " + house;

                                    let house_fias_id =
                                        suggestions["suggestions"][key]["data"][
                                            "house_fias_id"
                                            ];
                                    let street_fias_id =
                                        suggestions["suggestions"][key]["data"][
                                            "street_fias_id"
                                            ];

                                    let block_type =
                                        suggestions["suggestions"][key]["data"][
                                            "block_type"
                                            ];
                                    if (
                                        block_type == "лит" ||
                                        block_type == "литер"
                                    )
                                        block_type = "";
                                    if (block_type == "стр")
                                        block_type = " " + block_type + " ";
                                    let block =
                                        suggestions["suggestions"][key]["data"][
                                            "block"
                                            ];
                                    block =
                                        block === null ? "" : block_type + block;

                                    let city =
                                        suggestions["suggestions"][key]["data"][
                                            "city"
                                            ];
                                    let region =
                                        suggestions["suggestions"][key]["data"][
                                            "region"
                                            ];
                                    let region_with_type =
                                        suggestions["suggestions"][key]["data"][
                                            "region_with_type"
                                            ] || "";
                                    let area_with_type =
                                        ". " +
                                        suggestions["suggestions"][key]["data"][
                                            "area_with_type"
                                            ] +
                                        ". " || "";
                                    let settlement_with_type =
                                        suggestions["suggestions"][key]["data"][
                                            "settlement_with_type"
                                            ] || "";

                                    let uniqueAddress = "";
                                    if (
                                        suggestions["suggestions"][key]["data"][
                                            "block"
                                            ] &&
                                        suggestions["suggestions"][key]["data"][
                                            "block_type"
                                            ]
                                    ) {
                                        uniqueAddress =
                                            suggestions["suggestions"][key]["data"][
                                                "city_kladr_id"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "street_with_type"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "house"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "block_type"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "block"
                                                ];
                                    } else {
                                        uniqueAddress =
                                            suggestions["suggestions"][key]["data"][
                                                "city_kladr_id"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "street_with_type"
                                                ] +
                                            suggestions["suggestions"][key]["data"][
                                                "house"
                                                ];
                                    }

                                    // city = '<div class="city">' + city + '</div>';
                                    if (city) {
                                        city =
                                            city == region
                                                ? region_with_type
                                                : city;
                                    } else {
                                        city =
                                            region_with_type +
                                            area_with_type +
                                            settlement_with_type;
                                    }

                                    if (settlement_with_type) {
                                        city += ", " + settlement_with_type;
                                    }

                                    region = '<div class="city">' + city + "</div>";

                                    let div = document.createElement("div");

                                    div.innerHTML =
                                        '<div class="quiz-suggestion suggestions-item" data-id="' +
                                        street_fias_id +
                                        '"><div class="title suggestions__title">' +
                                        street +
                                        house_in +
                                        block +
                                        "</div>" +
                                        region +
                                        "</div>";

                                    quiz_suggestions_wrap.append(div);

                                    let address_list =
                                        document.querySelectorAll(
                                            ".quiz-suggestion"
                                        );
                                    address_list.forEach(function (item) {
                                        search_mask(
                                            item.querySelector(
                                                ".suggestions__title"
                                            ),
                                            reg_keyboard(e.target.value)
                                        );
                                        item.onclick = function (evt) {
                                            document.querySelector(
                                                ".quiz-address"
                                            ).value =
                                                item.querySelector(
                                                    ".suggestions__title"
                                                ).textContent + " ";
                                            street_id =
                                                item.getAttribute("data-id");
                                            sendOnChange(streetInp);
                                            document
                                                .querySelector(".quiz-address")
                                                .focus();
                                        };
                                    });
                                }
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                } else {
                    quiz_suggestions_wrap.innerHTML = "";
                    street_id = "";
                }
            }
        }

        form_quiz.addEventListener("submit", (event) => {
            event.preventDefault();
            form_quiz_button.innerHTML = "Отправка...";
            form_quiz_button.disabled = true;
            let request = {
                name: form_quiz.querySelector("[name=name]").value,
                phone: form_quiz.querySelector("[name=phone]").value,
                customer_text:
                    "Адрес: " +
                    form_quiz.querySelector("[name=address]").value +
                    "\n",
            };

            forEach(
                form_quiz.querySelectorAll("input:checked"),
                function (i, item) {
                    request.customer_text +=
                        item.name + ": " + item.value + "\n";
                }
            );

            if (request.phone.length < 18) {
                form_quiz
                    .querySelector(".placeholder-error")
                    .classList.remove("hide");
                form_quiz_button.innerHTML = form_quiz_button_t;
                return false;
            }

            postData(form_quiz.getAttribute("action"), request)
                .then((data) => {
                    if (data.success === true) {
                        modal_quiz
                            .querySelector(".modal-form-quiz-data")
                            .classList.add("hide");
                        modal_quiz
                            .querySelector(".search-address__results")
                            .classList.add("hide");
                        modal_quiz
                            .querySelector(".modal-quiz-flex")
                            .classList.remove("hide");
                        modal_quiz
                            .querySelector(".modal-form-quiz-result")
                            .classList.remove("hide");
                        form_quiz_button.innerHTML = form_quiz_button_t;
                    } else {
                        form_quiz_button.innerHTML = "Подобрать";
                        form_quiz.querySelector(".placeholder-error").classList.remove("hide");

                        setTimeout(() => {
                            form_quiz.querySelector(".placeholder-error").classList.add("hide");
                        }, 3000);

                        if (data.errors.phone) {
                            form_quiz.querySelector(".placeholder-error").innerHTML = data.errors.phone;
                        }
                    }
                })
                .catch(function (error) {
                    console.log(
                        "Не удалось отправить заявку, попробуйте позже."
                    );
                    form_quiz_button.innerHTML = form_quiz_button_t;
                })
                .finally(function (){
                    form_quiz_button.disabled = false;
                });
        });
    }
}

export default initModalQuiz;
